import { cva } from "class-variance-authority";

export { default as StatusBanner } from "./StatusBanner";
export { default as Task } from "./Task";
export { default as TaskStatus } from "./TaskStatus";
export { default as TaskDetails } from "./TaskDetails";
export { default as TaskDelete } from "./TaskDelete";
export { default as TaskLogMaterial } from "./TaskLogMaterial";
export { default as TaskLogTime } from "./TaskLogTime";
export { default as TaskTimeLog } from "./TaskTimeLog";
export { default as TaskMaterialLog } from "./TaskMaterialLog";
export { default as TaskPrimaryAction } from "./TaskPrimaryAction";

export const PrimaryActionType = Object.freeze({
    COMPLETE: "complete",
    REOPEN: "reopen",
    RESTORE: "restore",
});

export const primaryActions = {
    [PrimaryActionType.COMPLETE]: {
        id: PrimaryActionType.COMPLETE,
        label: "components.buttons.complete_task",
        type: "success",
        icon: "checkmark-default",
    },
    [PrimaryActionType.REOPEN]: {
        id: PrimaryActionType.REOPEN,
        label: "components.buttons.reopen_task",
        type: "filled",
        icon: "repeat",
    },
    [PrimaryActionType.RESTORE]: {
        id: PrimaryActionType.RESTORE,
        label: "components.buttons.restore_task",
        type: "filled",
        icon: "repeat",
    },
};

export const types = ["kanban", "list"];
export const viewports = ["mobile", "desktop"];

export const bannerVariants = cva(
    [
        "w-full",
        "flex",
        "items-center",
        "justify-between",
        "py-3",
        "border-secondary",
    ],
    {
        variants: {
            variant: {
                kanban: [
                    "h-10",
                    "px-4",
                    "bg-secondary",
                    "border",
                    "rounded-md",
                ],
                list: [
                    "group",
                    "transition-[border-radius]",
                    "ease-in-out",
                    "data-[state=open]:duration-50",
                    "data-[state=closed]:duration-300",
                    "data-[state=closed]:delay-200",
                    "cursor-pointer",
                    "data-[disabled]:cursor-default",
                ],
            },
            viewport: {
                mobile: [],
                desktop: [],
            },
        },
        compoundVariants: [
            {
                variant: "list",
                viewport: "mobile",
                class: [
                    "h-14",
                    "pl-4",
                    "pr-3",
                    "bg-primary",
                    "data-[state=open]:bg-tertiary",
                ],
            },
            {
                variant: "list",
                viewport: "desktop",
                class: [
                    "h-11",
                    "px-4",
                    "bg-secondary",
                    "data-[state=open]:border-b",
                    "rounded-md",
                    "data-[state=open]:rounded-b-none",
                ],
            },
        ],
    }
);
export const cardVariants = cva(
    [
        "group",
        "flex",
        "bg-primary",
        "hover:bg-primary_hover",
        "border-b",
        "border-b-secondary",
        "select-none",
        "cursor-pointer",
    ],
    {
        variants: {
            type: {
                kanban: ["rounded-md", "h-fit", "px-5", "py-4"],
                list: ["p-4"],
            },
            overdue: {
                true: [
                    "ltr:border-l-6",
                    "ltr:md:border-l-4",
                    "ltr:border-l-error",
                    "rtl:border-r-6",
                    "rtl:md:border-r-4",
                    "rtl:border-r-error",
                ],
            },
        },
        compoundVariants: [
            {
                type: "list",
                mobile: false,
                class: ["h-[84px]"],
            },
            {
                type: "list",
                mobile: true,
                class: ["py-3"],
            },
            {
                type: "list",
                overdue: true,
                class: [
                    "ltr:pl-2.5",
                    "ltr:md:pl-3",
                    "rtl:pr-2.5",
                    "rtl:md:pr-3",
                ],
            },
            {
                type: "kanban",
                overdue: true,
                class: ["ltr:pl-4", "rtl:pr-4"],
            },
        ],
    }
);
